export default __webpack_public_path__ + "static/media/forMia.ee84207f.mp3";